// pdf.js 4.x calls Promise.withResolvers in the PDFDocumentLoadingTask
// constructor. Browsers released before March 2024 lack it, so opening a PDF
// throws a TypeError. Import this module before any pdf.js module is evaluated.
// The pdf.js worker has its own global and is covered by the legacy worker.
declare global {
  interface PromiseConstructor {
    withResolvers<T>(): {
      promise: Promise<T>;
      resolve: (value: T | PromiseLike<T>) => void;
      reject: (reason?: unknown) => void;
    };
  }
}

export function installPromiseWithResolvers(): void {
  if (typeof Promise.withResolvers !== 'function') {
    Promise.withResolvers = function <T>() {
      let resolve: (value: T | PromiseLike<T>) => void;
      let reject: (reason?: unknown) => void;
      const promise = new Promise<T>((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { promise, resolve: resolve!, reject: reject! };
    };
  }
}

installPromiseWithResolvers();
